import React from 'react';

type Props = {
  className: string;
  children: React.ReactNode;
};

const TableWrapper = (props: Props) => {
  const { className, children } = props;

  return (
    <div className={className}>
      {children}
    </div>
  );
};

export default TableWrapper;
